import { Font, StyleSheet } from '@react-pdf/renderer';
Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

Font.register({
  family: 'FontAwesome',
  src: 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/webfonts/fa-solid-900.ttf',
});

export const styles = StyleSheet.create({
  body: {},

  smallText: {
    color: 'white',
    fontWeight: 400,
    fontSize: 9,
    fontFamily: 'Lato',
  },

  logoGrid: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
    marginLeft: 53,
    marginRight: 53,
    marginTop: 20,
  },
  logoWrapper: {
    backgroundColor: 'white',
    borderRadius: 5,
    width: '23%',
  },
  logoImage: {
    width: '100%',
    height: 'auto',
    maxHeight: '50px',
    borderRadius: 5,
    objectFit: 'cover',
  },

  statisticsGrid: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginTop: 20,
    marginBottom: 40,
    rowGap: 40,
    paddingHorizontal: 53,
    width: '100%',
  },
  statisticsItem: {
    width: '30%',
    flexDirection: 'row',
    gap: 10,
  },
  icon: {
    color: 'white',
    fontFamily: 'FontAwesome',
    fontSize: 16,
  },
  textWrapper: {
    flex: 1,
  },
  statTitle: {
    color: 'white',
    fontSize: 16,
    fontWeight: 700,
    fontFamily: 'Lato',
  },

  statDescription: {
    color: 'white',
    fontSize: 9,
    fontWeight: 400,
    fontFamily: 'Lato',
  },
});
